import React from 'react';

interface Props {
  onClick: () => void;
}

export const SubmitButton = ({ onClick }: Props) => {
  return (
    <button className='btn-bedrock-primary' onClick={onClick}>
      <span className='text-bedrock-p-strong'>Submit</span>
    </button>
  );
};
